// @TODO Should this just be an export in contexts/router.tsx?
import { useContext } from 'react';

import { RouterContext } from '../../contexts/router';

/**
 * Hook to access Ark UI's router state.
 */
export const useRouter = () => {
  const routerContext = useContext(RouterContext);
  if (!routerContext) {
    throw new Error('useRouter has to be used within <RouterProvider>');
  }
  return routerContext;
};
